<template>
    <div>
        <Listing ref="listing" api="/surveys" :title="title" :fields="fields" :filters-schema="filtersSchema" :filters="filters" @extra-data="onExtraData">
            <template #cell(stagiaires.genre)="{value}">
                <i class="bx font-size-24" :class="value == 'F' ? 'bx-female text-dark' : 'bx-male text-secondary'" :style="{ opacity: value == 'F' ? 1 : 0.55 }"></i>
            </template>
            <template #cell(stagiaires)="{value}">
                {{ value.nom }} {{ value.prenom }} <small class="text-muted">{{ value.cef }}</small>
            </template>
            <template #cell(filieres)="{value, item}">
                {{ value.nom }} <small class="text-muted">{{ item.annees.nom }}</small>
            </template>
            <template #cell(actions)="{item}">
                <div class="d-flex">
                    <b-button size="sm" variant="primary" @click="openSurvey(item)">Consulter</b-button>
                    <b-button class="ml-2" size="sm" variant="warning" @click="deleteSurvey(item)">
                        <i class="bx bx-loader bx-spin font-size-16 d-block" v-if="item.loading"></i>
                        <i class="bx bx-trash font-size-16 d-block" v-else></i>
                    </b-button>
                </div>
            </template>
            <template #cell(utilisateurs)="{value}">
                <small>{{ value.nom }}</small>
            </template>
            <!-- <template #cell(enquete)="{value: { count, done }}">
                <b-badge
                    class="py-1 px-2 font-size-11 font-weight-semibold"
                    :class="`bg-soft-${done == 0 ? 'secondary' : count == done ? 'primary' : 'warning'} text-${done == 0 ? 'secondary' : count == done ? 'primary' : 'warning'}`"
                    >{{ done }} / {{ count }}</b-badge
                >
            </template> -->
        </Listing>

        <SurveyModal :student="modalStudent" @submited="onSurveySubmited" />
    </div>
</template>

<script>
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Listing from "@/components/listing";
    import SurveyModal from "@/components/survey-modal";

    export default {
        page: {
            title: "Liste des enquêtes",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            PageHeader,
            Listing,
            SurveyModal
        },
        data: () => ({
            title: "Liste des enquêtes",
            fields: [
                { key: "id", label: "Num", tdClass: "font-weight-bold" },
                {
                    key: "date_modif_quest",
                    label: "Date",
                    formatter: value => new Date(value).toLocaleString("fr").replace(",", "")
                },
                { key: "stagiaires.genre", label: "Genre" },
                { key: "stagiaires", label: "Stagiaire" },
                { key: "stagiaires.tel", label: "Tél" },
                { key: "filieres", label: "Filière" },
                { key: "utilisateurs", label: "Crée par" },
                { key: "actions", label: "", class: "w-0" }
            ],
            filters: {
                idEfp: localStorage.getItem("selected-efp"),
                typeEfp: localStorage.getItem("selected-efp-type")
            },
            filtersData: {},
            modalStudent: {},
            loading: false
        }),
        methods: {
            onEFPChanged(id) {
                this.filters = { ...this.filters, idEfp: id, typeEfp: localStorage.getItem("selected-efp-type") };
            },
            onExtraData(data) {
                this.filtersData = data;
            },
            clearFilters() {
                const idEfp = localStorage.getItem("selected-efp");
                const typeEfp = localStorage.getItem("selected-efp-type");
                this.filters = {
                    idEfp,
                    typeEfp
                };
            },
            openSurvey(item) {
                console.log(item);
                this.modalStudent = {
                    nom: item.stagiaires.nom,
                    prenom: item.stagiaires.prenom,
                    filiere: item.filieres.nom,
                    stagiaireFiliere: item.id,
                    date: item.date_modif_quest
                };

                this.$nextTick(() => {
                    this.$bvModal.show("quest-modal");
                });
            },
            async deleteSurvey(item) {
                item.loading = true;
                await this.$axios.delete(`/surveys/${item.id}`);
                item.loading = false;
                this.$refs.listing.loadData();
            },
            onSurveySubmited() {
                this.$refs.listing.loadData();
            }
        },
        mounted() {
            this.mitt.on("efp-changed", this.onEFPChanged);
        },
        beforeDestroy() {
            this.mitt.off("efp-changed", this.onEFPChanged);
        },
        computed: {
            filtersSchema() {
                return {
                    groups: [
                        {
                            styleClasses: "row align-items-end",
                            fields: [
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Num",
                                    model: "id",
                                    debounce: 500,
                                    styleClasses: "col-1 font-size-12 text-muted"
                                },
                                {
                                    type: "datepicker",
                                    label: "Date",
                                    model: "date",
                                    range: true,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "b-input",
                                    inputType: "text",
                                    label: "Stagiaire",
                                    model: "stagiaire",
                                    debounce: 500,
                                    styleClasses: "col font-size-12 text-muted"
                                },
                                {
                                    type: "multiselect",
                                    label: "Genre",
                                    model: "genre",
                                    styleClasses: "col font-size-12 text-muted",
                                    selectOptions: {},
                                    values: [
                                        { id: "H", nom: "Masculin" },
                                        { id: "F", nom: "Féminin" }
                                    ]
                                },
                                {
                                    type: "multiselect",
                                    label: "Filières",
                                    model: "idFiliere",
                                    styleClasses: "col font-size-12 text-muted",
                                    values: this.filtersData.branchs || []
                                },
                                {
                                    type: "multiselect",
                                    label: "Année scolaire",
                                    model: "idAnnee",
                                    styleClasses: "col font-size-12 text-muted",
                                    values: this.filtersData.years || []
                                },
                                {
                                    type: "submit",
                                    buttonText: "Effacer",
                                    styleClasses: "col-auto",
                                    attributes: {
                                        class: "btn btn-light mb-1"
                                    },
                                    onSubmit: this.clearFilters
                                }
                            ]
                        }
                    ]
                };
            }
        }
    };
</script>
